//images
import OzonLogo from '../images/marketplace-ozon.svg';
import WbLogo from '../images/marketplace-wb.svg';
import YandexLogo from '../images/marketplace-yandex.svg';

export default function Marketplaces() {
    return (
        <div className="marketplace-links">
            <div className="marketplace-links__title">мы на маркетплейсах</div>
            <ul className="marketplace-links__list">
                <li className="marketplace-link">
                    <a
                        href="https://www.ozon.ru/seller/iek-group-ofitsialnyy-magazin-proizvoditelya-1412513/products/?miniapp=seller_1412513"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={OzonLogo} alt=""/>
                    </a>
                </li>
                <li className="marketplace-link">
                    <a
                        href="https://www.wildberries.ru/seller/3945038"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={WbLogo} alt=""/>
                    </a>
                </li>
                <li className="marketplace-link">
                    <a
                        href="https://market.yandex.ru/business--iek-group-ofitsialnyi-magazin-proizvoditelia/88342954?clid=703&generalContext=t%3DshopInShop%3Bi%3D1%3Bbi%3D88342954%3B&rs=eJwzkv7EKMHBKLDwEKsEg0bjcVaNs6dZNVYdYdV43s0DAHxgCW0%2C&searchContext=sins_ctx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={YandexLogo} alt=""/>
                    </a>
                </li>
            </ul>
        </div>
    );
}